export const getOrientation = (width: number, height: number) => {
  return width > height ? 'landscape' : 'portrait'
}
